import { render, staticRenderFns } from "./totalsData.vue?vue&type=template&id=27b73153&"
import script from "./totalsData.vue?vue&type=script&lang=js&"
export * from "./totalsData.vue?vue&type=script&lang=js&"
import style0 from "./totalsData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports